import { NgModule } from '@angular/core';
import { LicenseService } from './license.service';
import { StoreModule } from '@ngrx/store';
import * as fromLicense from './store/license.reducers';
import { EffectsModule } from '@ngrx/effects';
import { LicenseEffects } from './store/license.effects';
import { LicenseMessageDialogComponent } from './license-message-dialog/license-message-dialog.component';
import { LicenseHeaderMenuComponent } from './license-header/license-header-menu.component';
import { MaterialModule } from '../material/material.module';
import { TimeDisplayModule } from '../time-display/time-display.module';
import { CommonModule } from '@angular/common';
import { LicenseBlockerComponent } from './license-block/license-blocker.component';

@NgModule({
    providers: [LicenseService],
    declarations: [LicenseMessageDialogComponent, LicenseHeaderMenuComponent, LicenseBlockerComponent],
    exports: [LicenseBlockerComponent],
    imports: [
        CommonModule,
        MaterialModule,
        TimeDisplayModule,
        StoreModule.forFeature(fromLicense.licenseFeatureKey, fromLicense.licenseReducer, {
            metaReducers: fromLicense.metaReducers
        }),
        EffectsModule.forFeature([LicenseEffects])
    ]
})
export class LicenseModule {}
